import type { DemoState } from "./types";

export function createInitialState(): DemoState {
  return {
    wasmReady: false,
    app: null,
    connectionState: "idle",
    connectionDetail: "Not connected",
    lastEvent: null,
    hostedFile: null,
    marketplace: {
      activeStream: null,
      snapshot: null,
      streams: [],
    },
  };
}
